import axios from 'axios'

// A cancelled axios request is an expected outcome, not an error: e.g. the user answers "No" in the delete
// confirmation, which ApiService turns into `throw new axios.Cancel(...)`. Most callers do not catch it, so it
// would be reported to Sentry as "Object captured as promise rejection with keys: message".
export function dropCancelledRequests (event, hint) {
  return axios.isCancel(hint?.originalException) ? null : event
}

// Our code is served from the `js/` folder of the build (see output.filename in vue.config.js).
const BUNDLE_PATH = /\/js\/[^/]+\.js(\?|#|$)/

/**
 * True when the event has stack frames and none of them is in our bundle. Such an error is thrown by a script that a
 * browser or an extension injected into the page (e.g. crypto-wallet extensions touching `window.ethereum`): its frames
 * are the HTML document itself or `<anonymous>`. We cannot fix those. Events without any frame (plain messages) and
 * events with at least one bundle frame are kept.
 */
export function isInjectedScriptEvent (event) {
  const frames = (event?.exception?.values || []).flatMap(value => value?.stacktrace?.frames || [])

  if (frames.length === 0) {
    return false
  }

  return !frames.some(frame => BUNDLE_PATH.test(frame.abs_path || '') || BUNDLE_PATH.test(frame.filename || ''))
}

export function beforeSend (event, hint) {
  if (isInjectedScriptEvent(event)) {
    return null
  }

  return dropCancelledRequests(event, hint)
}
